import { render, staticRenderFns } from "./InCollectionsIndicator.vue?vue&type=template&id=aa245cac&"
import script from "./InCollectionsIndicator.vue?vue&type=script&lang=js&"
export * from "./InCollectionsIndicator.vue?vue&type=script&lang=js&"
import style0 from "./InCollectionsIndicator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports